export class CrmSettings {
	HistoryFilterEventTypeIDs = [1, 2, 3, 4, 5, 6, 7] as number[];

	constructor(data: any) {
		if (data?.HistoryFilterEventTypeIDs) {
			this.HistoryFilterEventTypeIDs = data.HistoryFilterEventTypeIDs;
		}
	}

	getJSON() {
		return {
			HistoryFilterEventTypeIDs: this.HistoryFilterEventTypeIDs,
		};
	}
}
